import Sandbox from '@/components/Sandbox';

const DrumMachineDemo = () => {
  return (
    <Sandbox
      title="Checkbox Demo"
      layout="split"
      size="wide"
      splitRatio={0.6}
      minPreviewHeight="12rem"
      dependencies={{
        'use-sound': '4.0.3',
      }}
      files={{
        '/App.js': `
import React from 'react';
import useSound from 'use-sound';

import styles from './DrumMachineDemo.module.css';

function DrumMachineDemo() {
  const soundUrl = '/sounds/909-drums.mp3';

  const [play] = useSound(soundUrl, {
    sprite: {
      kick: [0, 350],
      hihat: [374, 160],
      snare: [666, 290],
      cowbell: [968, 200],
    }
  });

  // Assign each drum sound to a key.
  // NOTE: You need to click/focus something inside the
  // preview pane for this to work.
  useKeyboardBindings({
    1: () => play({ id: 'kick' }),
    2: () => play({ id: 'hihat' }),
    3: () => play({ id: 'snare' }),
    4: () => play({ id: 'cowbell' }),
  })

  return (
    <div className={styles.wrapper}>
      <button
        aria-label="kick"
        className={styles.btn}
        onMouseDown={() => play({ id: 'kick' })}
      >
        1
      </button>
      <button
        aria-label="hihat"
        className={styles.btn}
        onMouseDown={() => play({ id: 'hihat' })}
      >
        2
      </button>
      <button
        aria-label="snare"
        className={styles.btn}
        onMouseDown={() => play({ id: 'snare' })}
      >
        3
      </button>
      <button
        aria-label="cowbell"
        className={styles.btn}
        onMouseDown={() => play({ id: 'cowbell' })}
      >
        4
      </button>
    </div>
  );
}

const useKeyboardBindings = (map) => {
  React.useEffect(() => {
    const handlePress = (ev) => {
      const handler = map[ev.key];

      if (typeof handler === 'function') {
        handler();
      }
    };

    window.addEventListener('keydown', handlePress);

    return () => {
      window.removeEventListener('keydown', handlePress);
    };
  }, [map]);
};

export default DrumMachineDemo;
        `,
        '/DrumMachineDemo.module.css': {
          hidden: true,
          code: `
.wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.btn {
  --size: 3rem;
  width: var(--size);
  height: var(--size);
  border: none;
  border-radius: 4px;
  color: white;
  background: hsl(210deg 15% 6%);
  font-weight: bold;
  transform-origin: center center;
  transition: transform 300ms;
}
.btn:active {
  background: hsl(240deg 95% 62%);
  transform: scale(0.9);
  transition: transform 0ms;
}
          `,
        },
      }}
    />
  );
};

export default DrumMachineDemo;
